
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { store } from '@/store/store';
import { setSupaEvents, setLoading, setError } from '@/store/supaEventsSlice';

interface CreateEventParams {
  slug: string;
  quarter: string;
  type: string;
  description: string | null;
  average: number | null;
  fabric_json1: any | null;
  fabric_json2: any | null;
}

export const createEvent = async ({
  slug,
  quarter,
  type,
  description,
  average,
  fabric_json1,
  fabric_json2
}: CreateEventParams) => {
  try {
    console.log('🔄 [eventsHelper] Creating/updating event:', { 
      slug, 
      quarter, 
      type,
      description,
      average 
    });

    const { data, error } = await supabase
      .from('events')
      .upsert(
        {
          slug,
          quarter,
          type,
          description,
          average,
          fabric_json1,
          fabric_json2
        },
        {
          onConflict: 'slug,quarter,type',
          ignoreDuplicates: false
        }
      )
      .select()
      .single();

    if (error) {
      console.error('❌ [eventsHelper] Error creating/updating event:', error);
      toast.error('Failed to save event');
      throw error;
    }

    // Update Redux store with the new/updated event
    const currentEvents = store.getState().supaEvents.events;
    const eventIndex = currentEvents.findIndex(e => 
      e.slug === slug && e.quarter === quarter && e.type === type
    );

    if (eventIndex !== -1) {
      // Update existing event
      const updatedEvents = [...currentEvents];
      updatedEvents[eventIndex] = data;
      store.dispatch(setSupaEvents(updatedEvents));
    } else {
      // Add new event
      store.dispatch(setSupaEvents([data, ...currentEvents]));
    }

    console.log('✅ [eventsHelper] Event saved:', data);
    toast.success('Event saved successfully');
    return data;

  } catch (error) {
    console.error('❌ [eventsHelper] Error:', error);
    toast.error('Failed to save event');
    throw error;
  }
};

export const fetchEvents = async () => {
  try {
    store.dispatch(setLoading(true));
    console.log('🔄 [eventsHelper] Fetching events...');

    const { data, error } = await supabase
      .from('events')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('❌ [eventsHelper] Error fetching events:', error);
      store.dispatch(setError(error.message));
      toast.error('Failed to fetch events');
      throw error;
    }

    console.log('✅ [eventsHelper] Events fetched:', data);
    store.dispatch(setSupaEvents(data));
    return data;

  } catch (error) {
    console.error('❌ [eventsHelper] Error:', error);
    toast.error('Failed to fetch events');
    throw error;
  } finally {
    store.dispatch(setLoading(false));
  }
};
